import { getPlanById, ONE_TIME_PRODUCTS } from "../config/plans";

export function normalizeKre8Role(role) {
  const normalized = String(role || "").trim().toLowerCase();
  if (normalized.includes("creator")) return "creator";
  if (normalized.includes("editor")) return "editor";
  return null;
}

export function getUserRole(userData = {}) {
  return normalizeKre8Role(
    userData?.profileInfo?.role ||
      userData?.role ||
      userData?.profile?.profileInfo?.role ||
      userData?.profile?.role
  );
}

export function getRequiredRoleForPlan(planId) {
  return getPlanById(planId)?.audience || null;
}

export function getRequiredRoleForProduct(productId) {
  return (
    ONE_TIME_PRODUCTS.find((product) => product.id === productId)?.audience ||
    null
  );
}

export function getRoleMismatchMessage({ userRole, requiredRole, itemName }) {
  const normalizedUserRole = normalizeKre8Role(userRole);
  const normalizedRequiredRole = normalizeKre8Role(requiredRole);

  if (!normalizedUserRole || !normalizedRequiredRole) return null;
  if (normalizedUserRole === normalizedRequiredRole) return null;

  const requiredLabel =
    normalizedRequiredRole === "creator" ? "creator" : "editor";
  const article = requiredLabel === "editor" ? "an" : "a";
  return `${itemName} is for ${requiredLabel} accounts. Switch to ${article} ${requiredLabel} account to use this upgrade.`;
}

export function getSignupIntent(searchParams) {
  const params =
    typeof searchParams === "string"
      ? new URLSearchParams(searchParams)
      : searchParams;
  const planId = params?.get?.("plan");
  const productId = params?.get?.("product");

  if (planId) {
    return {
      billingInterval: params.get("billing") || "monthly",
      id: planId,
      requiredRole: getRequiredRoleForPlan(planId),
      type: "subscription",
    };
  }

  if (productId) {
    return {
      id: productId,
      requiredRole: getRequiredRoleForProduct(productId),
      type: "purchase",
    };
  }

  return null;
}

export function roleLabelForSignup(role) {
  const normalized = normalizeKre8Role(role);
  if (normalized === "creator") return "Creator";
  if (normalized === "editor") return "Editor";
  return "";
}

export function formatSubscriptionDate(value) {
  if (!value) return "Not set";
  const date = typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "Not set";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
}

export function formatPurchaseAmount(amount, currency = "usd") {
  if (!Number.isFinite(Number(amount))) return "";

  return new Intl.NumberFormat("en-US", {
    currency: String(currency || "usd").toUpperCase(),
    style: "currency",
  }).format(Number(amount) / 100);
}
